import React from 'react';

import { Field } from 'react-final-form';
import NumberFormat from 'react-number-format';

const FormMoneyInput = ({
  label,
  required,
  placeholder,
  name,
  type = 'text',
  validate,
  handleValueChange,
  maxAmountWarningText,
}) => {
  return (
    <div className="form-field">
      <Field placeholder={placeholder} name={name} validate={validate}>
        {({ input, meta }) => (
          <div className={`form-group ${meta.error && meta.touched ? 'error' : ''}`}>
            <label htmlFor={`${name}`}>
              {label}
              <span className="required">{required ? '*' : ''}</span>
            </label>
            <NumberFormat
              {...input}
              autoComplete="off"
              prefix="$"
              thousandSeparator={true}
              allowEmptyFormatting
              onValueChange={handleValueChange}
            />

            {meta.error && meta.touched && <p className="error-text">{meta.error}</p>}
            {maxAmountWarningText && meta.touched && (
              <p className="warning-text">{maxAmountWarningText}</p>
            )}
          </div>
        )}
      </Field>
    </div>
  );
};

export default FormMoneyInput;
